/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useSelector } from 'react-redux';
import { getProject } from '../../../../selectors/projects';

// FIXME: Get this information from RQ instead of Redux
// @ts-ignore
const useReduxProject = ( projectID: number ) => useSelector( state => getProject( state, { projectID } ) );

export default useReduxProject;
